import posthog from "posthog-js";
import type { AdminMe } from "./api.js";

// The same PostHog project as web (D-0024). Only a production build sends anything; the panel has a handful of users,
// so it talks to PostHog directly rather than through a proxy of its own.
const PROJECT_KEY = "phc_n9F5ZnVUxtjZ7hwj3C5ST2sdP34n7qZdv79BZf9cQm2K";

let enabled = false;

export function initAnalytics() {
  if (!import.meta.env.PROD) return;
  posthog.init(PROJECT_KEY, {
    api_host: "https://us.i.posthog.com",
    ui_host: "https://us.posthog.com",
    defaults: "2026-08-30",
    person_profiles: "identified_only",
    capture_exceptions: true,
    enable_heatmaps: true,
    capture_performance: { web_vitals: true, network_timing: true },
  });
  const host = location.host;
  posthog.register({ environment: host.startsWith("admin.staging.") ? "staging" : host.startsWith("admin.") ? "production" : "local" });
  enabled = true;
}

export function identify(me: AdminMe) {
  if (!enabled || posthog.get_distinct_id() === me.id) return;
  posthog.identify(me.id, { email: me.email, name: me.name });
}

export function forget() {
  if (enabled && posthog._isIdentified()) posthog.reset();
}

/** An error a route boundary caught: it never reaches window.onerror, so it is reported here. */
export function captureError(err: unknown) {
  if (enabled) posthog.captureException(err);
}
